"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GetQuery = (key) => {
    return decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' +
        encodeURIComponent(key).replace(/[.+*]/g, '\\$&') +
        '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
};
exports.default = {
    GetQuery
};
